import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllTuTestimonials(_obj, params) {
    const res = await axios.get(`api/pathways/testimonials/`, { params });
    return res.data;
  },
  async getTuTestimonial(_obj, id) {
    const res = await axios.get(`api/pathways/testimonials/${id}/`);
    return res.data;
  },
  async createTuTestimonial(_obj, data) {
    return axios.post(`api/pathways/testimonials/`, data);
  },
  async updateTuTestimonial(_obj, { id, data }) {
    return axios.patch(`api/pathways/testimonials/${id}/`, data);
  },
  async deleteTuTestimonial(_obj, id) {
    return axios.delete(`api/pathways/testimonials/${id}/`);
  },
};

export const tuTestimonials = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
